export interface IInner {}

export interface IOutter {}

export type IProps = IInner & IOutter;

import {
	IWorkerAssignmentFranchiseListStore,
	TUnitSettingStore,
} from '@/stores';

import { DefaultOptionType } from 'antd/es/select';

export type DataType = IWorkerAssignmentFranchiseListStore;

export enum ESearchType {
	TYPE = 'TYPE',
	IS_CURRENT = 'IS_CURRENT',
	START_DATE = 'START_DATE',
	END_DATE = 'END_DATE',
	ASSIGNMENT_APPLICANT = 'ASSIGNMENT_APPLICANT',
	REQUEST_APPLICANT = 'REQUEST_APPLICANT',
	ADDITIONAL_ASSIGNMENT_APPLICANT = 'ADDITIONAL_ASSIGNMENT_APPLICANT',
	REGIST_DT = 'REGIST_DT',
	UPDATE_DT = 'UPDATE_DT',
	EMPLOYER_NAME = 'EMPLOYER_NAME',
}

export type TAssignRootOptionsProps = {
	fetchData?: () => void;
	isWorkerPublicAdminRole?: boolean;
	districtList?: DefaultOptionType[];
	publicFranchiseList?: DefaultOptionType[];
	optionalFieldFranchiseList?: TUnitSettingStore['optionalFieldFranchiseList'];
};
